<template>
  <div class="notesInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="notes">
        <template #title>
          <span>
            <img src="../../assets/svg/notesIcon.svg" alt="" />
            补充说明
          </span>
        </template>
        <div>
          <el-form
            ref="notesForm"
            :model="form"
            :rules="formRules"
            label-width="85px"
          >
            <el-form-item label="客户诉求" prop="customerDemand">
              <el-input
                v-if="!authStatus"
                v-model="form.customerDemand"
                :disabled="authStatus"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请输入客户诉求"
                @blur="inputBlur(form.customerDemand, 'customerDemand')"
                maxlength="500"
                show-word-limit
              ></el-input>
              <div class="problemDesInfo" v-else>{{form.customerDemand}}</div>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
export default {
  name: "notesInfo",
  data() {
    return {
      activeNames: ["notes"], // 全部展开
      form: {},
    };
  },
  props: {
    demandInfo: {
      type: [Array, Object],
      // default:() => []
    },
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    // 必填校验
    formRules() {
      const isRequired = !this.authStatus;
      return {
        customerDemand: [
          { required: isRequired, message: "请输入客户诉求", trigger: "blur" },
        ],
      };
    },
  },
  async created() {
    this.getDemandInfo();
  },
  methods: {
    // 获取数据
    getDemandInfo() {
      if (this.demandInfo) {
        this.form = this.demandInfo;
      }
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:demandInfo", this.form);
    },
    validateForm() {
      return this.$refs["notesForm"].validate()
        .then(() => ({ isValid: true, object: null }))
        .catch(errors => ({ isValid: false, object: errors }));
    },
  },
};
</script>
